(function(window, angular) {'use strict';

	var app = angular.module('app');

	/**
	 *
	 * Conversation App Controller
	 *
	 */
	app.controller('conversationController',
		['$scope', 'conversationService', 'userService', 'socketio', '$filter', '$timeout',
		function($scope, conversationService, userService, socketio, $filter, $timeout) {

		$scope.conversations = []; // all active conversations
		$scope.current = {}; // current conversation
		$scope.recipients = {};
		$scope.my_user_id = null;
		$scope.loading = true;

		$scope.init = function(user_id) {
			$scope.my_user_id = user_id;

			userService.search().then(function(users) {
				$scope.recipients.array = users;

				angular.forEach(users, function(user, idx) {
					user.user_id = user.id; // user_id is a recipient attribute
					delete(user.id);
					$scope.recipients['id' + user.user_id] = user;
				});

				conversationService.search().then(function(conversations) {
					$scope.conversations = conversations;
					angular.forEach($scope.conversations, function(conversation, idx) {
						conversation = $scope.initConversation(conversation);
					});

					if( $scope.conversations.length ) {
						// switch the newest conversation
						var newest_idx = 0;
						for( var idx = 1; idx<$scope.conversations.length; idx++ ) {
							if( $scope.conversations[newest_idx].updated_at < $scope.conversations[idx].updated_at ) {
								newest_idx = idx;
							}
						}

						if( $scope.conversations.length ) {
							$scope.conversations[newest_idx].init = true;
						}
						$scope.switchConversationIdx(newest_idx);
					}
				});
			});

			socketio.on(function(event) {
				event = angular.fromJson(event);

				if( event.event == 'conversation' ) {
					if( event.data.action == 'deleted' ) {
						var found_idx = null;
						angular.forEach($scope.conversations, function(conversation, idx) {
							if( conversation.id == event.data.conversation.id ) {
								found_idx = idx;
							}
						});
						if( found_idx ) {
							$scope.conversations.splice(found_idx,1);
						}
					}
				}
				else if( event.event == 'message' ) {
					var message = event.data.conversationMessage;

					if( message.conversation_id == $scope.current.id ) {
						$scope.appendMessage($scope.current, message);
						conversationService.markAsRead($scope.current);
					}
					else {
						var conversation_found = false;
						// add notification to the right conversation
						angular.forEach($scope.conversations, function(conversation, idx) {
							if( conversation.id == message.conversation_id ) {
								conversation_found = true;
								conversation.total_unread_messages++;
								$scope.appendMessage(conversation, message);
							}
						});

						if( !conversation_found ) {
							// try load this new conversation
							conversationService.get(message.conversation_id).then(function(conversation) {
								$scope.initConversation(conversation);
								$scope.appendMessage(conversation, conversation);
								$scope.conversations.push(conversation);
							});
						}
					}
				}
			});
		}

		$scope.initConversation = function(conversation) {
			if( !conversation.recipients ) {
				conversation.recipients = [];
			}
			if( !conversation.messages ) {
				conversation.messages = [];
			}

			//conversation.updated_at = new Date(conversation.updated_at);
			$scope.mapRecipients(conversation.recipients);
			conversation.updated_by_user = $scope.getRecipient(conversation.updated_by_user_id);

			return conversation;
		}

		$scope.appendMessage = function(conversation, new_message, mark_as_read) {
			new_message.recipient = $scope.getRecipient(new_message.updated_by_user_id);
			new_message.created_at = new Date(new_message.created_at);
			new_message.updated_at = new Date(new_message.updated_at);

			if( conversation.updated_at < new_message.created_at ) {
				conversation.updated_at = new_message.created_at;
			}

			// day separator (first date of the conversation and between 2 messages > 1 day)
			new_message.has_day_separator = false;
			var previous_date = null;
			var last_message_idx = conversation.messages.length - 1;
			if( last_message_idx >= 0 ) {
				previous_date = conversation.messages[last_message_idx].created_at;
			}
			if( !previous_date || (Math.abs(new_message.created_at - previous_date) >= 86400000) ) { // one day
				new_message.has_day_separator = true;
			}

			conversation.messages.push(new_message);
		}

		$scope.switchConversationIdx = function(idx) {
			if( !$scope.conversations.length ) {
				$scope.createConversation();
			}

			$scope.loading = true;

			// clamp idx
			idx = idx < 0 ? 0 : idx >= $scope.conversations.length ? $scope.conversations.length - 1: idx;

			if( $scope.current.id && $scope.current.total_unread_messages > 0 ) {
				// switch from init conversation (already marked as read in server side)
				$scope.current.total_unread_messages = 0;
			}

			// switch to idx conversation
			$scope.current = $scope.conversations[idx];

			if( $scope.current.id ) {
				$scope.current.messages = []; // reset before reloading

				$scope.loading_messages = true;
				conversationService.searchMessages($scope.current).then(function(messages) {
					$scope.current.messages = [];
					angular.forEach(messages, function(message, idx) {
						$scope.appendMessage($scope.current, message);
					});
					$scope.loading_messages = false;
				}, function(error) {
					$scope.loading_messages = false;
				});
			}

			// mark as read if it's not the switch from init (current is empty)
			var total = $scope.current.total_unread_messages;
			conversationService.markAsRead($scope.current).then(function(conversation) {
				if( conversation.init ) {
					conversation.total_unread_messages = total;
					delete(conversation.init);
				}
			});

			$scope.loading = false;
		}

		$scope.switchConversation = function(conversation) {
			var idx = $scope.conversations.indexOf(conversation);
			if( idx == -1 ) {
				return;
			}
			$scope.switchConversationIdx(idx);
		}

		$scope.getRecipient = function(user_id) {
			var id = 'id' + user_id;

			if( $scope.recipients[id] ) {
				return $scope.recipients[id];
			}

			return null;
		}
		$scope.mapRecipients = function(recipients) {
			angular.forEach(recipients, function(recipient, idx) {
				var ret = $scope.getRecipient(recipient.user_id);
				if( ret ) {
					recipient = angular.extend(recipient, ret);
				}
			});
		}

		$scope.clickSubject = function() {
			if( $scope.current.editing && $scope.current.editing.subject == '' ) {
				$scope.current.editing.subject = '';
			}
		}

		$scope.createConversation = function() {
			for( var i=0; i<$scope.conversations.length; i++ ) {
				if( !$scope.conversations[i].id ) {
					// already get one new and unsaved conversation
					return;
				}
			}
			var conversation = $scope.initConversation({
				subject: '',
				updated_by_user_id: $scope.my_user_id,
				recipients: [{user_id:$scope.my_user_id}],
			});

			var idx = $scope.conversations.length;
			$scope.conversations[idx] = conversation;
			$scope.toggleEditConversation(conversation);

			$scope.switchConversationIdx(idx);
		}

		$scope.saveConversation = function(conversation) {
			$scope.loading = true;
			conversationService.save(conversation).then(function(updated_conversation) {
				$scope.loading = false;
				updated_conversation = $scope.initConversation(updated_conversation);
			});
		}

		$scope.sendNewMessage = function() {

			if( !$scope.new_message || $scope.new_message == '' ) {
				$scope.new_message = null;
				return;
			}

			$scope.loading = true;
			var message = {
				text: $scope.new_message
			};
			conversationService.sendMessage($scope.current, message).then(function(message) {
				$scope.loading = false;
				if( !$scope.current.messages ) {
					$scope.current.messages = [];
				}
				//$scope.current.messages.push(message);
				$scope.new_message = '';
			}, function(error) {
				$scope.loading = true;
			});
		}

		/*$scope.recipientAlreadyAdded = function(user) {
			if( $scope.current.recipients ) {
				for( var i=0; i<$scope.current.recipients.length; i++ ) {
	        		if( $scope.current.recipients[i].user_id == user.user_id ) {
	        			return false;
	        		}
	        	}
	        }
        	return true;
    	};

    	$scope.addRecipient = function(user) {
    		if( !$scope.current.recipients ) {
    			$scope.current.recipients = [];
    		}
    		$scope.current.recipients.push({user_id:user.user_id});
    		$scope.saveConversation($scope.current);
    	}

		$scope.removeRecipientFromConversation = function(conversation, recipient) {
			var idx = conversation.recipients.indexOf(recipient);
			if( idx == -1 ) {
				return;
			}

			conversation.recipients.splice(idx, 1);

			if( conversation.id ) {
				$scope.loading = true;
				conversationService.save(conversation).then(function(updated_conversation) {
					$scope.loading = false;
					updated_conversation = $scope.initConversation(updated_conversation);
				});
			}
		}*/

		$scope.deleteConversation = function(conversation) {
			console.log(conversation);
			var idx = $scope.conversations.indexOf(conversation);
			if( idx < 0 || idx>= $scope.conversations.length ) {
				return;
			}

			conversation.loading = true;
			var doneCallback = function() {
				$scope.conversations.splice(idx, 1);

				if( $scope.conversations.length == 0 ) {
					$scope.current = {};
				}

				$scope.switchConversationIdx(idx != 0 ? 0 : 1);
			}

			console.log(conversation);

			var conversation = $scope.conversations[idx];
			if( conversation.id ) {
				conversationService.delete(conversation).then(function() {
					doneCallback();
				}, function(error) {
					conversation.loading = false;
				});
			}
			else {
				doneCallback();
			}
		}

		$scope.toggleEditConversation = function(conversation, save) {
			if( conversation.is_editing ) {
				if( save ) {
					// map the new recipients
					var new_recipients = $filter('filter')(conversation.editing.recipients, {is_member:true});

					if( new_recipients.length <= 1 ) {
						return;
					}

					// apply modifications
					conversation.loading = true;
					conversation.subject = conversation.editing.subject;
					conversation.recipients = new_recipients;

					conversationService.save(conversation).then(function(updated_conversation) {
						$scope.loading = false;
						conversation.loading = false;
						updated_conversation = $scope.initConversation(updated_conversation);
					}, function(error) {
						conversation.loading = false;
						console.log(error);
					});
				}
				else if( !conversation.id ) {
					// cancel on non save conversation => delete
					$scope.deleteConversation(conversation);
				}
			}
			else {
				// init for edition
				conversation.editing = {
					subject:conversation.subject,
					recipients: $scope.recipients.array,
					all_recipients: true,
				};


				angular.forEach(conversation.editing.recipients, function(editing_recipient, idx) {
					editing_recipient.is_member = false;
					angular.forEach(conversation.recipients, function(current_recipient, jdx) {
						if( current_recipient.user_id == editing_recipient.user_id ) {
							editing_recipient.is_member = true;
						}
					});

					if( !editing_recipient.is_member ) {
						conversation.editing.all_recipients = false;
					}
				});
			}

			conversation.is_editing =! conversation.is_editing;
		}

		$scope.toggleAllRecipients = function(conversation) {
			angular.forEach(conversation.editing.recipients, function(recipient, idx) {
				if( recipient.user_id == $scope.my_user_id ) {
					recipient.is_member = true;
				}
				else {
					recipient.is_member = conversation.all_recipients;
				}
			});
		}
	}]);

})(window, window.angular);
